import { reactive, ref } from 'vue';

class Toast {
	static toasts = reactive([]);
	static isHover = ref(false);
	static timers = new Map();

	constructor() {
		if (!Toast.instance) {
			Toast.instance = this;
		}
		return Toast.instance;
	}

	static clearTimer(toastId) {
		const timer = Toast.timers.get(toastId);
		if (!timer) return;

		clearInterval(timer);
		Toast.timers.delete(toastId);
	}

	showToast({ message, duration = 3000, replaceExisting = false, ...props }) {
		if (Toast.toasts.length >= 1) {
			if (!replaceExisting) return;

			Toast.toasts.forEach((toast) => Toast.clearTimer(toast.id));
			Toast.toasts.splice(0, Toast.toasts.length);
			Toast.isHover.value = false;
		}

		const newToast = {
			message,
			duration,
			id: `id-${Date.now().toString(36)} - ${Math.random().toString(36).substring(2, 9)}`,
			...props,
		};

		Toast.toasts.push(newToast);

		if (duration <= 0) return;

		let timer = 0;

		const interval = setInterval(() => {
			if (!Toast.isHover.value) timer += 500;

			if (timer >= duration) {
				const toastIndex = Toast.toasts.findIndex((toast) => toast.id === newToast.id);
				if (toastIndex !== -1) Toast.toasts.splice(toastIndex, 1);

				Toast.clearTimer(newToast.id);
			}
		}, 500);

		Toast.timers.set(newToast.id, interval);
	}

	hideToast(toastId) {
		const toastIndex = Toast.toasts.findIndex((toast) => toast.id === toastId);
		if (toastIndex === -1) return;

		Toast.clearTimer(toastId);
		Toast.isHover.value = false;
		Toast.toasts.splice(toastIndex, 1);
	}
}

export default Toast;
